import {announceAnnotationChange} from './AnnotationAnnouncer';
import {useAnnotationModeStore} from '../store/AnnotationModeStore';
import {selectAnnotation, selectMarkSubject} from '../store/annotationSelectors';
import type {Annotation} from '../types';

/**
 * Speaks about a stored mark, read back after the write so the message names the style
 * the store gave it (a supplement mark never takes underline). Null stays quiet.
 */
export function announceMarkChange(
  regionId: string,
  id: string,
  describe: (mark: Annotation, subject: string) => string | null
): void {
  const state = useAnnotationModeStore.getState();
  const mark = selectAnnotation(state, regionId, id);
  const message = mark && describe(mark, selectMarkSubject(state, mark));
  if (message) {
    announceAnnotationChange(message);
  }
}
